module.exports = __webpack_public_path__ + "static/media/bv.ce747379.svg";